// const INTERNAL_API_BASE =
//   import.meta?.env?.VITE_API_BASE ||
//   process.env.REACT_APP_API_BASE ||
//   "https://projet-collect-v1-production.up.railway.app";

// const MAX_WAIT_MS = 3000;
// let isPatched = false;

// function waitForAuthReady() {
//   return new Promise((resolve) => {
//     if (window.__AUTH_READY__) return resolve();
//     let waited = 0;
//     const interval = setInterval(() => {
//       if (window.__AUTH_READY__ || waited >= MAX_WAIT_MS) {
//         clearInterval(interval);
//         resolve();
//       }
//       waited += 50;
//     }, 50);
//   });
// }

// function isInternalApi(url) {
//   try {
//     const full = new URL(url, window.location.href);
//     return full.origin === INTERNAL_API_BASE;
//   } catch {
//     return false;
//   }
// }

// function patchFetch() {
//   if (isPatched) return;
//   isPatched = true;
//   console.log("📡 fetch patched! Waiting for auth + JWT fallback on internal API requests.");

//   const originalFetch = window.fetch;

//   window.fetch = async (...args) => {
//     const [input, init = {}] = args;
//     const url = typeof input === 'string' ? input : input.url;

// if (
//   isInternalApi(url) &&
//   !url.includes("/api/login") &&
//   !url.includes("/api/login2-test") &&
//   !url.includes("/api/checkAuth") &&
//   !url.includes("/api/logout")
// ) {
//   await waitForAuthReady();

//       // 🔥 Add credentials: 'include' if missing
//       init.credentials = init.credentials || 'include';

//       // 🔥 Add Authorization header if jwtToken exists
//       const jwtToken = localStorage.getItem('jwtToken'); // fallback JWT
//       if (jwtToken) {
//         init.headers = {
//           ...init.headers,
//           Authorization: `Bearer ${jwtToken}`,
//         };
//       }
//     }

//     const res = await originalFetch(input, init);
//     const unauthorized = res.status === 401 || res.status === 403;

//     if (isInternalApi(url) && unauthorized && window.location.pathname !== "/login") {
//       console.warn("Unauthorized. Dispatching login modal event...");
//       window.dispatchEvent(new CustomEvent("show-login-modal"));
//     }

//     return res;
//   };
// }

// // ⏳ Delay patching slightly to ensure backend is fully ready
// function delayedPatchFetch() {
//   setTimeout(patchFetch, 500); // 500ms delay
// }

// if (document.readyState === "complete" || document.readyState === "interactive") {
//   delayedPatchFetch();
// } else {
//   window.addEventListener("DOMContentLoaded", delayedPatchFetch);
// }import { getJwtToken, getCsrfToken } from './utils/authUtils';
import { getJwtToken, getCsrfToken } from './utils/authUtils';

const INTERNAL_API_BASE =
  import.meta?.env?.VITE_API_BASE ||
  process.env.REACT_APP_API_BASE ||
  "https://projet-collect-v1-production.up.railway.app";

const MAX_WAIT_MS = 5000; // Wait max 5s for AuthContext readiness
let isPatched = false;

function waitForAuthReady() {
  return new Promise((resolve) => {
    if (window.__AUTH_READY__) return resolve();
    let waited = 0;
    const interval = setInterval(() => {
      if (window.__AUTH_READY__ || waited >= MAX_WAIT_MS) {
        clearInterval(interval);
        resolve();
      }
      waited += 50;
    }, 50);
  });
}

function waitForSessionCookie() {
  return new Promise(async (resolve) => {
    let retries = 0;
    while (!document.cookie.includes('session_cookie') && retries < 10) {
      console.log(`⏳ Waiting for session_cookie (${retries + 1}/10)...`);
      await new Promise(r => setTimeout(r, 200)); // Wait 200ms
      retries++;
    }
    if (document.cookie.includes('session_cookie')) {
      console.log("✅ session_cookie found.");
    } else {
      console.warn("⚠️ session_cookie not found after retries.");
    }
    resolve();
  });
}

function isInternalApi(url) {
  try {
    const full = new URL(url, window.location.href);
    return full.origin === INTERNAL_API_BASE;
  } catch {
    return false;
  }
}

function patchFetch() {
  if (isPatched) return;
  isPatched = true;
  console.log("📡 fetch patched! Session + JWT + CSRF fallback enabled.");

  const originalFetch = window.fetch;

  window.fetch = async (...args) => {
    const [input, init = {}] = args;
    const url = typeof input === 'string' ? input : input.url;

    if (isInternalApi(url)) {
      await waitForAuthReady();

      init.credentials = init.credentials || 'include'; // 🍪 Always send cookies
      console.log("🚀 fetchPatch credentials:", init.credentials);

      // Get JWT + CSRF from authUtils
const jwtToken = getJwtToken();
const csrfToken = getCsrfToken();

console.log("🧪 jwtToken in fetchPatch:", jwtToken);
console.log("🧪 csrfToken in fetchPatch:", csrfToken);

init.headers = {
  ...init.headers,
  ...(jwtToken && jwtToken !== 'null' && jwtToken !== 'undefined' ? { Authorization: `Bearer ${jwtToken}` } : {}),
  ...(csrfToken ? { 'x-csrf-token': csrfToken } : {})
};
    }

    console.log("🔗 [FETCH]", url);
    console.log("📤 Request Headers:", init.headers);
    console.log("🍪 Cookies at fetch:", document.cookie);

    const res = await originalFetch(input, init);
    console.log(`📥 Response (${res.status}):`, url);

    if ((res.status === 401 || res.status === 403) && isInternalApi(url)) {
      console.warn("🚨 Unauthorized. Retrying after session warm-up...");
      await waitForSessionCookie();
      await originalFetch(`${INTERNAL_API_BASE}/api/ping`, { credentials: 'include' });
      return originalFetch(input, init); // Retry once
    }

    return res;
  };
}

function delayedPatchFetch() {
  setTimeout(patchFetch, 500); // Delay slightly to let AuthContext mount
}

if (document.readyState === "complete" || document.readyState === "interactive") {
  delayedPatchFetch();
} else {
  window.addEventListener("DOMContentLoaded", delayedPatchFetch);
}
